// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"ee5d273d","124":"961230f1","631":"ed7c9beb","740":"b9789df9"}[chunkId] + ".chunk.js";
};